import axios from "axios";

const fetchClient = () => {
  const defaultOptions = {
    // baseURL: 'http://localhost:4000',
    baseURL: process.env.REACT_APP_API_PATH,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Create instance
  let instance = axios.create(defaultOptions);

  // Set the AUTH token for any request
  instance.interceptors.request.use(function (config) {
    const token = localStorage.getItem("token");
    config.headers.Authorization = token;
    return config;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.log(error);
      const status = error.response?.status;
      if (status === 401) {
        // Token inválido ou expirado
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        window.location.href = "/";
      } else if (status === 403) {
        // Permissão negada - redirecionar para página de não autorizado
        console.error("Acesso negado:", error.response?.data);
        window.location.href = "/unauthorized";
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export default fetchClient();
